// =============================================================================
// GraphQL Subscriptions — ResolveGuru AppSync
// =============================================================================

// Fires whenever a new entry is written to a session's timeline.
// Used by the Plan Approval page to refresh when a revised PLAN arrives.
// data is AWSJSON — callers must JSON.parse() it after receiving.
export const onSessionEntry = /* GraphQL */ `
  subscription OnSessionEntry($sessionId: ID!) {
    onSessionEntry(sessionId: $sessionId) {
      sessionId
      sortKey
      entryType
      data
      agentId
      status
      createdAt
      ttl
    }
  }
`;
